module.exports = __webpack_public_path__ + "static/img/guard_privilege_icon3.0c78651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_privilege_icon3.png
// module id = sEh6
// module chunks = 0